import { createCommands } from 'utils/commands';

export const editorCopilotDropdownCommands = createCommands([
  {
    group: 'richTextEditor',
    label: 'Improve reply',
    name: 'improveReply',
    description: 'Opens the Improve reply modal',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyP'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Match to style guide',
    name: 'matchToStyleGuide',
    description:
      'Improves the selected text in the editor to match the applicable style guide',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyY'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: "Translate selected text to conversation's language",
    name: 'translateToConversationLanguage',
    description:
      'Translates the selected text in the editor to the language of the conversation',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyT'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Translate selected text',
    name: 'translate',
    description: 'Translates the selected text in the editor',
  },
  {
    group: 'richTextEditor',
    label: 'Check spelling and grammar',
    name: 'checkSpellingAndGrammar',
    description:
      'Checks the spelling and grammar of selected text in the editor',
    keyboard: {
      keybindings: [{ binding: [[], 'F7'] }],
    },
  },
  {
    group: 'richTextEditor',
    label: 'Expand reply',
    name: 'expandText',
    description:
      'Enriches the selected text in the editor to provide more context',
    keyboard: {
      keybindings: [{ binding: [['$metaOrCtrl', 'Shift'], 'KeyX'] }],
    },
  },
]);
